import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { SavingsService } from "@main-services/savings.service";
import { SavingsPlan } from "@models/savings_plan";
import { CustomModal } from "../../../../../core/components/base-modals";

@Component({
	selector: "savings-failed",
	templateUrl: "./savings-failed.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class SavingsFailedComponent extends CustomModal {
	@Input()
	public data: SavingsPlan;

	public constructor(
		protected router: Router,
		protected savingsService: SavingsService
	) {
		super();
	}

	public goToSavings(): void {
		this.close();
		setTimeout(() => {
			// The Backbutten handling in Modals screws this if you dont delay it a little
			this.router.navigateByUrl("/savings");
		}, 300);
	}

	public showModal(component, data): void {
		const modal = this.modalService.create(component, { data });
		this.modalService.pop();
		modal.present();
	}

	public tryAgain(): void {
		this.savingsService.getPaymentDetails(this.data);
	}
}
